import React, { useState } from "react";
import { createEndCustomerPaid, getFiles } from "API/swesum";
import { useLoaderData, useNavigate } from "react-router-dom";
import usePost from "Hooks/usePost";
import Typography from "@mui/material/Typography";
import Paper from "Components/UI/Paper";
import Grid from "@mui/material/Grid";

import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import EndCustomerPaidForm from "Components/Endcustomerpaid/EndCustomerPaidForm";
import { usePopupNotificationContext } from "Context/NotificationPopup";

export async function loader() {
  const files = await getFiles();
  return { files };
}

const initialState = {
  Amount: 0,
  InvoiceId: "",
  File: "",
  OCR: "",
  AccountRefId: "",
  EndCustomerName: "",
};

export function CreateEndCustomerPaid() {
  const [formData, setFormData] = useState(initialState);
  const { files } = useLoaderData();
  const { openError } = usePopupNotificationContext();

  const createInvoiceReq = usePost({
    mtnFunc: (body) => createEndCustomerPaid(body),
    onError: () => {
      openError("Ett fel uppstod när fakturan skapades.");
    },
    onSuccess: (data) => {
      navigate(`/endcustomerpaid/${data.Id}`);
    },
  });

  const navigate = useNavigate();

  const handleInputChange = (field, newVal) => {
    setFormData({ ...formData, [field]: newVal });
  };

  return (
    <>
      <Box component="main" sx={{ flexGrow: 1, p: 5 }}>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2 }}>
          <Grid item xs={12} md={12}>
            <Paper>
              <Typography sx={{ marginBottom: "2rem" }} variant="h5">
                Skapa Slutkundsinbetalning
              </Typography>
              <EndCustomerPaidForm
                formData={formData}
                files={files}
                handleInputChange={handleInputChange}
              />

              <Grid
                item
                xs={12}
                md={12}
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Button onClick={() => navigate(-1)}>Stäng</Button>
                <Button
                  sx={{ ml: 3 }}
                  onClick={() => createInvoiceReq.post(formData)}
                  variant="contained"
                >
                  Spara
                </Button>
              </Grid>
            </Paper>

            {createInvoiceReq.loading && <Typography>{"Laddar"}</Typography>}
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
